<button type="button" mat-icon-button [matMenuTriggerFor]="switcher">
  <mat-icon [svgIcon]="current"></mat-icon>
</button>
<mat-menu #switcher="matMenu">
  <button mat-menu-item *ngFor="let lang of availableLanguages"
          (click)="onLanguageChange(lang.name)">
    <mat-icon [svgIcon]="lang.icon"></mat-icon> {{ lang.caption }}
  </button>
</mat-menu>

